module.exports = {"id":"168312","name":"Ignazio Abate","rating":"78","photo":"./data/images/photos/1/168312.png","club":{"name":"Milan","logo":"./data/images/clubs/Milan.png"},"positions":["DD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/IgnazioAbate0.json
// module id = 1784
// module chunks = 0